import { ApolloQueryResult } from 'apollo-boost';
import { removeConnections } from 'shared/apollo';
import { FeedbackFilters } from 'shared/components/Feedback/FeedbackDashboardFilterBar';
import {
  AllPortfolioFilters,
  AllRelationshipManagerFilters,
  AdminAccounts,
} from 'shared/components/Feedback/FiltersDropdown/api';

export const mapRelationshipFilters = (
  x: ApolloQueryResult<AllRelationshipManagerFilters>,
) => {
  const response: AllRelationshipManagerFilters['relationshipManagers'] = removeConnections(
    x.data.relationshipManagers,
  );
  const result: {filters: FeedbackFilters } = {
    filters: {},
  };
  for (const r of response) {
    result.filters[r.dbId] = {
      name: `${r.firstName} (${r.email})`,
      value: r.dbId.toString(),
    };
  }
  return {
    data: result,
  };
};

export const mapPortfolioFilters = (
  x: ApolloQueryResult<AllPortfolioFilters>,
): { data: { count: number; filters: FeedbackFilters } } => {
  const response: AllPortfolioFilters['allPortfolios'] = removeConnections(
    x.data.allPortfolios,
  );
  const result: { count: number; filters: FeedbackFilters } = {
    count: response.length,
    filters: {},
  };
  for (const r of response) {
    result.filters[r.portfolioId] = {
      name: r.name,
      count: `ID: ${r.portfolioId}`,
      value: r.portfolioId.toString(),
    };
  }
  return {
    data: result,
  };
};

export const mapDonorFilters = (
  x: ApolloQueryResult<AdminAccounts>,
): { data: { count: number; filters: FeedbackFilters } } => {
  const response: AdminAccounts['adminAccounts'] = removeConnections(x.data.adminAccounts);
  const result: { count: number; filters: FeedbackFilters } = {
    count: response.length,
    filters: {},
  };
  for (const r of response) {
    result.filters[r.dbId] = {
      name: r.name,
      count: `ID: ${r.dbId}`,
      value: r.dbId.toString(),
    };
  }
  return {
    data: result,
  };

};